module.exports = "images/weeklogo2.2.svg";